export default {
  billingSummary: "Here's a summary of your upcoming billing.",
  successTitle: (addOnName: string): string => `You now have ${addOnName}  🙌`
};
